import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AppComponent } from './app.component';
import { SayDesignSystemModule } from '../../projects/say-design-system/src/lib/say-design-system.module';
import { CoreModule } from './core/core.module';
import { RouterModule } from '@angular/router';
import { appRoutes } from './app.routes';
import { HighlightModule } from 'ngx-highlightjs';
import { SharedModule } from './shared/shared.module';
import { IconsPageComponent } from './pages/icons-page/icons-page.component';
import { ModalsPageComponent } from './pages/modals-page/modals-page.component';
import { DialogsPageComponent } from './pages/dialogs-page/dialogs-page.component';
import { BreakpointsPageComponent } from './pages/breakpoints-page/breakpoints-page.component';
import { AlertsPageComponent } from './pages/alerts-page/alerts-page.component';
import { ThemesPageComponent } from './pages/themes-page/themes-page.component';
import { FormsModule } from '@angular/forms';
import { BannerPageComponent } from './pages/banner-page/banner-page.component';
import { TogglesPageComponent } from './pages/toggles-page/toggles-page.component';
import { FormsPageComponent } from './pages/forms-page/forms-page.component';
import { HeaderFooterPageComponent } from './pages/header-footer-page/header-footer-page.component';
import { PaginationPageComponent } from './pages/pagination-page/pagination-page.component';

@NgModule({
    declarations: [
        AppComponent,
        IconsPageComponent,
        ModalsPageComponent,
        DialogsPageComponent,
        BreakpointsPageComponent,
        AlertsPageComponent,
        ThemesPageComponent,
        BannerPageComponent,
        TogglesPageComponent,
        FormsPageComponent,
        HeaderFooterPageComponent,
        PaginationPageComponent
    ],
    imports: [
        RouterModule.forRoot(
            appRoutes,
            { enableTracing: true} // Debugging
        ),
        BrowserModule,
        SayDesignSystemModule,
        CoreModule,
        HighlightModule.forRoot(),
        SharedModule,
        FormsModule
    ],
    providers: [],
    bootstrap: [AppComponent],
    entryComponents: [IconsPageComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}